// components/NavBar/MenuToggle.jsx

import React from "react";
import { motion } from "framer-motion";
import "./NavBar.scss";

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    stroke="#F8F2EA"
    strokeLinecap="round"
    {...props}
  />
);

export const MenuToggle = ({ toggle, open, mobile }) => {
  const handleToggle = () => {
    toggle();
  };

  return (
    <>
      <button
        onClick={handleToggle}
        className={`motion-button ${mobile ? "mobile" : ""}`}
        aria-label="Menu Button"
      >
        <svg width="22" height="20" viewBox="0 0 22 20">
          <Path
            variants={{
              closed: { d: "M 2 4 L 20 4" },
              open: { d: "M 3 2.5 L 17 16.346" },
            }}
            animate={open ? "open" : "closed"}
            initial="closed"
          />
          <Path
            d="M 2 10 L 20 10"
            initial={{ opacity: 1 }} 
            variants={{
              closed: { opacity: 1 },
              open: { opacity: 0 },
            }}
            animate={open ? "open" : "closed"}
            transition={{ duration: 0.1 }}
          />
          <Path
            variants={{
              closed: { d: "M 2 16 L 20 16" },
              open: { d: "M 3 16.5 L 17 2.5" },
            }}
            animate={open ? "open" : "closed"}
            initial="closed"
          />
        </svg>
      </button>
    </>
  );
};
